// extracted by mini-css-extract-plugin
module.exports = {"link":"PaymentMethodSection_link__1qNaD","disabled":"PaymentMethodSection_disabled__1Su7E"};